module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/2/3-1696ddf3c587b7484252a251d3b2c51a.jpg";